import Chip from './Chip';

export default function CurriculumTable( { data }){
    return(
        <div>
            <h3>Curriculum</h3>
            <div className = "curriculum-container">
                { data.map( ( item, index ) => (
                    <div className = "curriculum" key = { index }>
                        <p style = { { flex : 1 } }>📄 { item.properties.Name.title[0].plain_text }</p>

                        <div style = { { display : "flex", flexDirection : "row", gap : "16px", alignItems : "center", justifyContent : "center" } }>
                            { item.properties.Membership?.select === null && (
                                <a href = { `/blog/${item.id}` } target = "_blank">Link</a>
                            )}
                            <Chip txt = { item.properties.Membership?.select === null ? "Free" : "🔒 Membership" } backgroundColor = { item.properties.Membership?.select === null ? "var(--pt8)" : "var(--black8)" }/>
                            <p style = { { fontSize : "12px" } }>🕐 { item.properties.Summary.rich_text[0].plain_text }</p>
                        </div>
                    </div>
                )) }
            </div>
        </div>
    )
}